import { Divider, Grid, List } from "@mui/material";
import OrganizationFavouriteLocationListItem from "./OrganizationFavouriteLocationListItem";
// import VehicleClassMappingsListItem from "./VehicleClassMappingsListItem";

const OrganizationFavouriteLocationsList = ({
  organizationFavouriteLocationsData,
  onItemDeleteClick,
}: {
  organizationFavouriteLocationsData: any;
  onItemDeleteClick: (organizationFavouriteLocation: any) => void;
}) => {
  return (
    <List>
      {organizationFavouriteLocationsData?.map(
        (organizationFavouriteLocation: any, index: number) => (
          <OrganizationFavouriteLocationListItem
            id={organizationFavouriteLocation?.id}
            displayName={organizationFavouriteLocation?.displayName}
            address={organizationFavouriteLocation?.address}
            onDeleteClick={() => {
              onItemDeleteClick(organizationFavouriteLocation);
            }}
          />
        )
      )}
    </List>
  );
};

export default OrganizationFavouriteLocationsList;
